var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex reason-card"},[_vm._t("image"),_c('div',{},[_vm._t("heading"),_c('p')],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }